import authService from './auth.service';

const API_URL = '/api/v1';
const ROLES_BASE = `${API_URL}/task-manager/assignment-roles`;

export interface AssignmentRoleDTO {
  id: number;
  code: string;
  name: string;
  description?: string | null;
}

/**
 * Список AssignmentRole из task-manager.
 * Используется:
 *   - TransitionInspector (dropdown выбора required_role)
 *   - TransitionButtons (role chip lookup по role_id)
 *   - AssignmentRolesContext (cached registry)
 */
class AssignmentRolesService {
  async listRoles(): Promise<AssignmentRoleDTO[]> {
    const response = await authService.fetchWithAuth(ROLES_BASE);
    if (!response.ok) {
      throw new Error(`Failed to list assignment roles: ${response.statusText}`);
    }
    const data = await response.json();
    return Array.isArray(data) ? (data as AssignmentRoleDTO[]) : (data?.items ?? []);
  }
}

export default new AssignmentRolesService();
